export default __webpack_public_path__ + "static/simple-area-0c1dcf5f19c4942104c0853ea8fd0de5.png";